module.exports = __webpack_public_path__ + "img/B262.a58f05b1.png";